import states from '@/helpers/rave/constants/centerDefinitionStates'

export default {
  [states.UNDEFINED]: 'Open',
  [states.DEFINED]: 'Defined'
}
